import { render } from "./NavbarDesktop.vue?vue&type=template&id=9591b9a2&scoped=true"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js"

import "./NavbarDesktop.vue?vue&type=style&index=0&id=9591b9a2&scoped=true&lang=css"
import "./NavbarDesktop.vue?vue&type=style&index=1&id=9591b9a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9591b9a2"]])

export default __exports__